import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import CountryListItem from '@features/footer/components/LanguageSelect/CountryListItem/CountryListItem';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import Heading from '@components/Heading/Heading';
import Aside from '@components/Aside/Aside';
import styles from '@features/footer/components/LanguageSelect/LanguageSelect.styles';
import { useRegionsStore } from '@features/footer/components/LanguageSelect/mobX/context/RegionStoreProvider';
const LanguageSideBar = () => {
  const {
    t
  } = useTranslation('layouts');
  const {
    closeSidebar,
    isSideBarOpen,
    regions,
    currentOffer,
    currentLocale
  } = useRegionsStore();
  return <ErrorBoundary>
      <Aside active={isSideBarOpen} onCloseAside={closeSidebar}>
        <div sx={styles.sidebarContent}>
          <div sx={styles.sidebarHeaderContainer}>
            <Heading h={3} headingType={4} uppercase bold>
              {t('footer.countryAndLanguage')}
            </Heading>
          </div>
          <div sx={styles.sidebarMainContent}>
            <Heading h={4} headingType={4} mobile>
              {t('footer.languageSelectDescription')}
            </Heading>
            <ul sx={styles.sidebarListWrapper}>
              {regions && Object.keys(regions).length > 0 && regions.map(el => <CountryListItem key={el.name} region={el} currentLocale={currentLocale} currentOffer={currentOffer} />)}
            </ul>
          </div>
        </div>
      </Aside>
    </ErrorBoundary>;
};
export default observer(LanguageSideBar);